import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM16.911 9.75001L15.4968 8.3358L10.9968 12.8358L8.99676 10.8358L7.58255 12.25L10.9968 15.6642L16.911 9.75001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareCheck;
